import React from 'react';
import { useSelector } from 'react-redux';

function LoadingMask() {
  const loading = useSelector((state) => state.loading ? state.loading.loading : state.loadingReducer ? state.loadingReducer.loading : false);

  if (!loading) return null;

  const overlayStyle = {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(68, 68, 68, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000,
  };

  return (
    <div style={overlayStyle} aria-hidden="true">
      <div className="text-center">
        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  );
}

export default LoadingMask;
